import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import WorkCalendarsTableActions from '@/components/work-calendars/WorkCalendarsTableActions.vue';
import type { WorkCalendar } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<WorkCalendar>[] = [
    {
        accessorKey: 'name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'work-calendars.table.name',
            }),
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'tables.actions',
            }),
        cell: ({ row }) => {
            return h(WorkCalendarsTableActions, {
                workCalendar: row.original,
            });
        },
    },
];
